import { BottomBarConfig } from './bottom-bar.config';
import { LogLevel } from 'src/app/shared/logging/LogLevel';

export const environmentBase = {
  production: false,
  logLevel: LogLevel.Debug,
  adminHostURL: 'https://admin.testgodev.nl',
  helpHostURL: 'https://gonnaorder.com/help/',
  hostURL: 'https://gonnaorder.com/',
  stagingHost: 'testgodev',
  VAPID_PUBLIC_KEY:
    'BH-cXEE6u4oWK61uILsQVZx_8DmGIXVXJzorS0bgADLqr5kzw9A6QV6DiHaazrUYxOUWH-BnByRroMYOvxnXpzY',
  myNextEndpointUrl: 'https://nextadmin.azurewebsites.net/api/',
  name: window['env'].name, // environment name
  facebookClientId: window['env'].facebookClientId, // facebook sso client id
  facebookClientToken: window['env'].facebookClientToken,
  facebookApiVersion: 'v26.0', // web sdk only (native apps use their facebook sdk default); keep equal to user-info-uri in stores-backend-config and -local
  envDomain: window['env'].envDomain, // gonna order environment domain
  defaultDeeplinkAppId: 'com.gonnaorder.godev',
  defaultDeeplinkAppAndroidUrl:
    'https://play.google.com/store/apps/details?id=com.gonnaorder.godev',
  defaultDeeplinkAppIOSUrl:
    'https://apps.apple.com/nl/app/gonnaorder/id1566767814?l=en',
  googleMapAPIKeyWeb: window['env'].googleMapAPIKey,
  googleMapAPIKeyAndroid: 'AIzaSyDqrsxrZHwhXEGXGfhpIJGY8c4q30EKiZw',
  googleMapAPIKeyIOS: 'AIzaSyBoZTcSXNM1k8Qmid-6lqlsHMmqrLhP0BY',
  hubriseLoginUrl:
    'https://manager.hubrise.com/oauth2/v1/authorize?redirect_uri={{gonnaorder_uri}}/hubrise-user-login&client_id={{client_id}}&scope=location[orders.write,customer_list.write,catalog.write]&country={{country}}&account_name={{account_name}}',
  hubriseClientId: window['env'].hubriseClientId,
  eventsBackendURL: 'https://dev.api.thexo.app', // events backend url
  eventsAppURL: 'https://dev.app.thexo.app', // events public app url
  // DNA Payments browser SDK. Held here rather than taken from the launch URL: the launch page is
  // reachable by link, so a caller-supplied script source would execute on the storefront origin.
  //
  // Sandbox platform, and it is this base that develop AND staging build from: stores-ui/Dockerfile
  // runs `build:prod` (the only configuration that file-replaces environment.ts with
  // environment.prod.ts, i.e. the only one reaching environment.base.prod.ts) when
  // ENVIRONMENT=production, and `build:dev:sourcemap` otherwise — and .github/workflows/staging.yml
  // passes ENVIRONMENT=staging, develop.yml ENVIRONMENT=develop. Only master.yml passes production.
  // So staging charges on DNA's sandbox, which is what the test plan needs. The pair must move
  // together with the platform the backend mints its token on (stores-backend-config's
  // dnapayments.api.* hosts, per environment): a page opened on pay.dnapayments.com with a token
  // minted on test-pay fails on DNA's own page, off our site.
  dnaPaymentsScriptUrl:
    'https://test-pay.dnapayments.com/checkout/payment-api.js',
  dnaPaymentsTestMode: true,
  firebaseConfig: {
    // firebase configuration
    apiKey: 'AIzaSyD9SfnOCskFaUzk2u2zXuGyLAbjy0EVHoQ',
    authDomain: 'goadmin-d621f.firebaseapp.com',
    projectId: 'goadmin-d621f',
    storageBucket: 'goadmin-d621f.appspot.com',
    messagingSenderId: '982274508593',
    appId: '1:982274508593:web:281374a78063f446c39210',
    measurementId: 'G-S2BRD6HWWN',
  },
  webSocketTopic: '/topic/events.orders.',
  webSocketEndPoint: 'wss://admin.testgodev.nl/go',
  fcmTopicPrefix: 'develop-fcm-topic-order-',
  // Promotion pushes to the template apps (#11620) ride their own topic
  // family so an order alert and a promotion can never collide.
  fcmPromotionTopicPrefix: 'develop-fcm-topic-promo-',
  templateStoreAlias: '',
  appId: '',
  tenantDomain: '',
  recaptchaSiteKey: '6LdKOm0sAAAAAO5gruG5InlT1kjPb06ZugLXER4R',
  bottomBar: {
    enabled: false,
    tabs: [],
  } as BottomBarConfig,
};
